import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunk from "redux-thunk";
import ordiniDiSpedizioneReducer from "./ordini-di-spedizione/reducer";
import simReducer from "./sim/reducer";
import authReducer from "./auth/reducer";
import serviceRequestReducer from "./service-request/reducer";
import reportReducer from "./report/reducer";
import richiesteAssistenzaReducer from "./richieste-assistenza/reducer";
import deviceReducer from "./device/reducer";
import digitalContractReducer from "./digital-contract/reducer";
import eventiReducer from './soglia-eventi/eventi/reducer';
import sogliaReducer from "./soglia-eventi/soglia/reducer";
import modificheEffettuateReducer from "./soglia-eventi/modifiche-effettuate/reducer";
import contrattoDigitaleReducer from "./contratto-digitale/reducer";
import ordiniConsipReducer from "./ordini-consip/reducer";
import eSimReducer from "./e-sim/reducer";
import devicesReducer from "./device-v2/reducer";

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const rootReducer = combineReducers({
    ordiniDiSpedizioneReducer: ordiniDiSpedizioneReducer,
    simReducer: simReducer,
    authReducer: authReducer,
    serviceRequestReducer: serviceRequestReducer,
    reportReducer: reportReducer,
    richiestaAssistenzaReducer: richiesteAssistenzaReducer,
    deviceReducer: deviceReducer,
    contrattoDigitaleReducer: contrattoDigitaleReducer,
    sogliaReducer: sogliaReducer,
    eventiReducer: eventiReducer,
    modificheReducer: modificheEffettuateReducer,
    digitalContractReducer: digitalContractReducer,
    ordiniConsipReducer: ordiniConsipReducer,
    eSimReducer: eSimReducer,
    devicesReducer: devicesReducer
});

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
